import { Container, List, ListItem, Sheet, sheetClasses } from '@mui/joy'
import Grid from '@mui/joy/Grid'
import React from 'react'
import Typography from '@mui/joy/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate, useParams } from 'react-router-dom'
import {
  useDeleteRewardMutation,
  useGetMyRewardsQuery,
} from '../services/rewards'
import Reward from './Reward'
import RewardsLoading from './RewardsLoading'
import EmptyRewards from './EmptyRewards'

function Rewards() {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()

  const { data: rewardsData, isLoading: isGetRewardsLoading } =
    useGetMyRewardsQuery(id ?? '')

  const [, { isLoading: isDeleteRewardLoading }] = useDeleteRewardMutation({
    fixedCacheKey: 'shared-delete-reward',
  })

  function goTo(route: string) {
    navigate(route)
  }

  if (isGetRewardsLoading || isDeleteRewardLoading) {
    return <RewardsLoading />
  }

  if (rewardsData?.length === 0) {
    return <EmptyRewards />
  }

  return (
    <Container>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
      >
        <Grid sx={{ pb: 2, pt: 2 }}>
          <Typography
            level="h4"
            sx={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
            onClick={() => goTo('/')}
          >
            <ArrowBackIcon />
            Vissza az üzleteimhez
          </Typography>
        </Grid>

        <Container maxWidth="sm">
          <Sheet variant="soft">
            <List
              aria-labelledby="ios-example-demo"
              sx={(theme) => ({
                '& ul': {
                  '--List-gap': '0px',
                  bgcolor: 'background.surface',
                  '& > li:first-child > [role="button"]': {
                    borderTopRightRadius: 'var(--List-radius)',
                    borderTopLeftRadius: 'var(--List-radius)',
                  },
                  '& > li:last-child > [role="button"]': {
                    borderBottomRightRadius: 'var(--List-radius)',
                    borderBottomLeftRadius: 'var(--List-radius)',
                  },
                },
                '--List-radius': '8px',
                '--List-gap': '1rem',
                '--ListDivider-gap': '0px',
                '--ListItem-paddingY': '0.5rem',
                '--joy-palette-neutral-plainHoverBg': 'rgba(0 0 0 / 0.08)',
                '--joy-palette-neutral-plainActiveBg': 'rgba(0 0 0 / 0.12)',
                [theme.getColorSchemeSelector('light')]: {
                  '--joy-palette-divider': 'rgba(0 0 0 / 0.08)',
                },
                [theme.getColorSchemeSelector('dark')]: {
                  '--joy-palette-neutral-plainHoverBg':
                    'rgba(255 255 255 / 0.1)',
                  '--joy-palette-neutral-plainActiveBg':
                    'rgba(255 255 255 / 0.16)',
                },
              })}
            >
              <ListItem nested>
                <List
                  aria-label="Network"
                  sx={{
                    [`& .${sheetClasses.root}`]: {
                      p: 0.5,
                      lineHeight: 0,
                      borderRadius: 'sm',
                    },
                  }}
                >
                  {(rewardsData ?? []).map((reward) => (
                    <Reward key={reward.id} id={reward.id} />
                  ))}
                </List>
              </ListItem>
            </List>
          </Sheet>
        </Container>
      </Grid>
    </Container>
  )
}

export default Rewards
